export default __webpack_public_path__ + "static/media/credit-card-logos-stripe1.373ab116.png";